import styled, { css } from 'styled-components';

export const SWrapper = styled.div`
  margin-bottom: 6px;
  border-radius: 4px;
  overflow: hidden;
`;

export const SList = styled.ul`
  display: flex;
  height: 70px;
  margin: 0;
  padding: 0;
  list-style: none;
  text-align: center;
  gap: 1px;
`;

export const SItem = styled.li`
  flex: 1 0;
  background: rgba(40, 234, 27, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
`;

export const SLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  opacity: 0.5;
  text-transform: uppercase;
  margin-bottom: 6px;
`;

export const SValue = styled.div<{ color?: 'green' }>`
  font-size: 14px;
  font-weight: 400;
  padding: 0 2px;

  ${({ color }) =>
    color === 'green' &&
    css`
      color: rgb(52, 199, 89);
    `}
`;
